import type { Session, User, AuthError } from "@supabase/supabase-js";
import { supabase } from "@/infrastructure/supabase/client";

export interface AuthResult {
  session: Session | null;
  user: User | null;
  error: AuthError | null;
}

export const authRepository = {
  async getSession(): Promise<Session | null> {
    const { data } = await supabase.auth.getSession();
    return data.session;
  },

  async signInWithPassword(email: string, password: string): Promise<AuthResult> {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    return { session: data.session, user: data.user, error };
  },

  async signUpWithPassword(email: string, password: string): Promise<AuthResult> {
    const { data, error } = await supabase.auth.signUp({ email, password });
    return { session: data.session, user: data.user, error };
  },

  async signOut(): Promise<{ error: AuthError | null }> {
    const { error } = await supabase.auth.signOut();
    return { error };
  },

  onAuthStateChange(callback: (session: Session | null) => void) {
    const { data } = supabase.auth.onAuthStateChange((_event, session) => callback(session));
    return () => data.subscription.unsubscribe();
  },
};
